export function truncate() {
	const els = document.querySelectorAll('.truncate--lines')
	if (!els.length) return

	const check = (el) => {
		el.classList.toggle('is-truncated', el.scrollHeight > el.clientHeight + 1)
	}

	const ro = new ResizeObserver((entries) => {
		entries.forEach((entry) => check(entry.target))
	})

	els.forEach((el) => {
		check(el)
		ro.observe(el)
	})
}
